'use client';

import { useCallback, useEffect, useState } from 'react';

/**
 * Seconds left of a client-side wait (resending the activation link or the reset e-mail): `start(60)` begins it,
 * `remaining` counts down to 0 once a second from the real end time, so a throttled tab stays right.
 */
export function useCooldown() {
  const [endsAt, setEndsAt] = useState(0);
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!endsAt) return;
    const tick = () => {
      const left = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
      setRemaining(left);
      if (!left) setEndsAt(0);
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [endsAt]);

  const start = useCallback((seconds: number) => setEndsAt(Date.now() + seconds * 1000), []);

  return { remaining, start };
}

/** 75 → „1:15“ (the `{cas}` of „Znova môžete poslať o {cas}“). */
export function formatCountdown(seconds: number) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
